padLen